<template>
  <slot>
    <div v-show="!state.hidden" :id="identifier">
      <label class="govuk-label" v-show="!state.hiddenLabel" v-html="displayName"></label>
      <span :id="titleId" class="govuk-title" v-html="displayTitle"></span>
      <span :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></span>
      <span class="govuk-display-hint" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText"></span>
      <span :id="errorId" class="govuk-error-message"></span>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/Label.ts"></script>